import { render, staticRenderFns } from "./Partenaire.vue?vue&type=template&id=5c94bc83&"
import script from "./Partenaire.vue?vue&type=script&lang=js&"
export * from "./Partenaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports